import request from '../../../../../../utils/request';
import Form from './edit-adjust';
import SelectBudgetFee from './selectBudgetFee';

export default {
  name: 'form-edit-adjust',
  props: {
    formConfig: Object,
    value: Object,
  },
  components: {
    LeftForm: Form,
    RightForm: Form,
  },
  data() {
    return {
      leftSelect: {},
      rightSelect: {},
      editLeft: {},
      editRight: {},
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          const that = this;
          this.leftSelect = {
            feeBudgetCode: val.srcFeeBudgetCode,
            budgetYearName: val.srcBudgetYear,
            budgetSubjectsName: val.srcBudgetSubjectsName,
            customerName: val.srcCustomerName,
            ext8: val.srcExt8,
            orgName: val.srcOrgName,
            productLevelName: val.srcProductLevelName,
            initAmount: val.srcInitAmount,
            canUseAmount: val.srcCanUseAmount,
            changeAmount: val.changeAmount,
            afterAdjustAmount: val.srcAfterAdjustAmount,
            businessRemarks: val.businessRemarks,
            attachmentList: val.attachmentList,
          };
          this.rightSelect = {
            feeBudgetCode: val.targetFeeBudgetCode,
            budgetYearName: val.targetBudgetYear,
            budgetSubjectsName: val.targetBudgetSubjectsName,
            customerName: val.targetCustomerName,
            ext8: val.targetExt8,
            orgName: val.targetOrgName,
            productLevelName: val.targetProductLevelName,
            initAmount: val.targetInitAmount,
            canUseAmount: val.targetCanUseAmount,
            afterAdjustAmount: val.targetAfterAdjustAmount,
          };
          setTimeout(() => {
            that.editLeft = that.leftSelect;
            that.editRight = that.rightSelect;
            that.$refs.leftForm.disabled(false, ['changeAmount', 'businessRemarks', 'attachmentList']);
            if (that.formConfig.code === 'view') {
              that.$refs.leftForm.disabled(true, ['changeAmount', 'businessRemarks', 'attachmentList']);
            }
            that.$emit('setChangeData', that);
          }, 1000);
        }
      },
    },
  },
  created() {},
  methods: {
    handleInitRightChange(row, type) {
      this.rightSelect = row;
      if (type === 'init') {
        this.$refs.leftForm.disabled(false, ['changeAmount', 'businessRemarks', 'attachmentList']);
      } else {
        this.$refs.leftForm.setValue({ changeAmount: 0, businessRemarks: '', attachmentList: null });
      }
      this.$emit('setChangeData', this);
    },
    handleFieldLeftChange(value, type) {
      if (type === 'init') {
        this.leftSelect = value;
      } else if (type === 'replace') {
        this.leftSelect = value;
        this.rightSelect = {};
      } else {
        const canUseAmount = this.$refs.rightForm.getFieldValue('canUseAmount');
        const num = value ? Number(canUseAmount) + Number(value) : Number(canUseAmount);

        this.$refs.rightForm.setValue({
          afterAdjustAmount: num,
        });
      }
      this.$emit('setChangeData', this);
    },
    // 关闭弹窗
    closeModal() {
      this.$emit('onClose');
    },
  },
  render() {
    const handleFieldLeftChange = this.handleFieldLeftChange.bind(this);
    const handleInitRightChange = this.handleInitRightChange.bind(this);
    return (
      <div>
        <el-row>
          <el-col span={12}>
            <h2 style={{ fontSize: '16px' }}>调出方</h2>
            {this.leftSelect && (this.leftSelect.id || this.leftSelect.feeBudgetCode) ? (
              <LeftForm
                ref={'leftForm'}
                functionCode="tmp_budget_fee_form_edit_adjust"
                modalType="left"
                rowId={this.leftSelect.id}
                feeBudgetCode={this.leftSelect.feeBudgetCode}
                onFieldChange={handleFieldLeftChange}
                editLeft={this.editLeft}
                buttonCode={this.formConfig.code}
              ></LeftForm>
            ) : (
                <SelectBudgetFee
                  v-model={this.leftSelect}
                  code={this.rightSelect.feeBudgetCode}
                  onChange={handleFieldLeftChange}
                ></SelectBudgetFee>
            )}
          </el-col>
          <el-col span={12}>
            <h2 style={{ fontSize: '16px' }}>调入方</h2>
            {this.rightSelect && (this.rightSelect.id || this.rightSelect.feeBudgetCode) ? (
              <RightForm
                ref={'rightForm'}
                functionCode="tmp_budget_fee_form_edit_adjust"
                modalType="right"
                rowId={this.rightSelect.id}
                feeBudgetCode={this.rightSelect.feeBudgetCode}
                onFieldChange={handleInitRightChange}
                editRight={this.editRight}
                buttonCode={this.formConfig.code}
              ></RightForm>
            ) : (
              <SelectBudgetFee
                v-model={this.rightSelect}
                code={this.leftSelect.feeBudgetCode}
                onChange={handleInitRightChange}
              ></SelectBudgetFee>
            )}
          </el-col>
        </el-row>
      </div>
    );
  },
};
